import { render, staticRenderFns } from "./ImportOrders.vue?vue&type=template&id=171e1f2c&scoped=true&"
import script from "./ImportOrders.vue?vue&type=script&lang=js&"
export * from "./ImportOrders.vue?vue&type=script&lang=js&"
import style0 from "./ImportOrders.vue?vue&type=style&index=0&id=171e1f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171e1f2c",
  null
  
)

export default component.exports